import React, { useState , useEffect } from 'react';
import axios from 'axios';
import { TiTick } from "react-icons/ti"; // React Icons
import { IoIosArrowDropdown } from 'react-icons/io'; // Dropdown Icon
import NavbarBanner from '../components/NavbarBanner';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
// import FbxModel from '../components/FbxModel';
import Stats from '../components/Stats';
// import { assets } from '../assets/assets';
import Testimonials from '../components/Testimonials';
const About = () => {
  
    useEffect(() => {
    const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
    axios.post(`${backendUrl}/api/analytics/visit`, { page: "About" })
      .then(res => console.log("About page visit recorded:", res.data))
      .catch(err => console.error("Analytics error:", err));
  }, []);

  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();
  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };
  
  const dropdownData = [
    {
      title: 'Graphic Design Services',
      content: 'We offer creative graphic design solutions tailored to your brand.',
    },
    {
      title: 'Printing Services',
      content: 'High-quality printing services for all your needs.',
    },
    {
      title: 'POD for online stores',
      content: 'Print-on-demand services to elevate your online store.',
    },
    {
      title: 'Branding & white-label printing',
      content: 'Customized branding and white-label printing for businesses.',
    },
  ];

  // const testimonialsData = [
  //   {
  //     photo: assets.avt4, // Replace with an actual photo URL
  //     name: "Mammoth",
  //     designation: "Primal Beast",
  //     review: "Great quality products - These are much better than leopard skin. Fabric is comfortable and comes in various designs.",
  //   },
  //   {
  //     photo: assets.avt8, // Replace with an actual photo URL
  //     name: "Sabertooth",
  //     designation: "King of Wild",
  //     review: "Finally! This product is fit for royalty! Stylish, eco-friendly, and strong like me. Paws down, the best! Trendy designs, but the fabric isn't claw-proof.",
  //   },
  //   {
  //     photo: assets.avt12, // Replace with an actual photo URL
  //     name: "Vasuki Indicus",
  //     designation: "Emperor Snake",
  //     review: "Stretchy enough to fit my 50-foot frame! Plus, the moisture-wicking fabric is a lifesaver in the tropical heat.",
  //   },
  //   {
  //     photo: assets.avt1, // Replace with an actual photo URL
  //     name: "Titanoboa",
  //     designation: "King of Snakes",
  //     review: "As a 40-foot-long snake, I know a thing or two about needing a perfect fit! These shirts? Impressive. The fabric stretches better than my scales during a meal.",
  //   },
  //   {
  //     photo: assets.avt5, // Replace with an actual photo URL
  //     name: "T-Rex",
  //     designation: "Beast Incarnate",
  //     review: "I’ve got short arms but BIG style. These t-shirts? Absolutely Dino-mite! The fit is roar-some, and the designs are so sharp, they could rival my teeth.",
  //   },
  //   {
  //     photo: assets.avt9, // Replace with an actual photo URL
  //     name: "Megalodon",
  //     designation: "Monster of Sea",
  //     review: "As a 60-foot apex predator, I’ve seen the depths of the ocean, but these shirts? They're deeper in quality than the Mariana Trench!",
  //   },
  //   {
  //     photo: assets.avt2, // Replace with an actual photo URL
  //     name: "Mosasaurus",
  //     designation: "King of Marina Trench",
  //     review: "As a prehistoric marine reptile, fashion wasn’t really my thing back in the Cretaceous. But these T-shirts? Absolute legends!",
  //   },
  //   {
  //     photo: assets.avt6, // Replace with an actual photo URL
  //     name: "Diprotodon",
  //     designation: "",
  //     review: "As a prehistoric giant who’s all about comfort, I must say this brand hits the mark! The shirts are as soft as the grasslands.",
  //   },
  //   {
  //     photo: assets.avt10, // Replace with an actual photo URL
  //     name: "Quetzalcoatlus",
  //     designation: "Queen of Sky",
  //     review: "As a creature with a 40-foot wingspan, finding t-shirts that capture my soaring style is nearly impossible. But this brand? Absolutely sky-high!",
  //   },
  //   {
  //     photo: assets.avt3, // Replace with an actual photo URL
  //     name: "Ankylosaurus",
  //     designation: "",
  //     review: "As a dino built for protection, I know durable when I see it—and these t-shirts are rock-solid!",
  //   },
  //   {
  //     photo: assets.avt7, // Replace with an actual photo URL
  //     name: "Pterodactyl",
  //     designation: "Air Marshall",
  //     review: "As a high-flyer, I need t-shirts that can keep up with my aerial lifestyle! This brand? Absolutely soaring. The designs are bold enough to make me stand out.",
  //   },
  //   {
  //     photo: assets.avt11, // Replace with an actual photo URL
  //     name: "Brachiosaurus",
  //     designation: "Savior of Forest",
  //     review: "As a towering giant, I need a t-shirt that can handle my size. And let me tell you, this brand doesn’t disappoint! The material is sturdy yet breathable.",
  //   },
  // ];
  

  const [currentIndex, setCurrentIndex] = useState(0);
  const cardsToShow = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1; // Adjust this based on screen size

  const handlePrev = () => {
    // Scroll to the previous set of cards
    setCurrentIndex((prev) =>
      prev - cardsToShow < 0 ? 0 : prev - cardsToShow
    );
  };

  // const handleNext = () => {
  //   // Scroll to the next set of cards
  //   setCurrentIndex((prev) =>
  //     prev + cardsToShow >= testimonialsData.length
  //       ? testimonialsData.length - cardsToShow
  //       : prev + cardsToShow
  //   );
  // };


  // const nextSlide = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
  // };

  // const prevSlide = () => {
  //   setCurrentIndex(
  //     (prevIndex) => (prevIndex - 1 + testimonialsData.length) % testimonialsData.length
  //   );
  // };

  const extractKeywords = () => {
    const dropdownKeywords = dropdownData
      .map((item) => `${item.title}, ${item.content}`)
      .join(', ');
  
    // const testimonialsKeywords = testimonialsData
    //   .flatMap((item) => [item.name, item.designation, item.review])
    //   .filter(Boolean)
    //   .join(', ');
  
    const keywordsSet = new Set(
      `${dropdownKeywords}`.split(', ').map((word) => word.trim())
    );

    // , ${testimonialsKeywords}
  
    return Array.from(keywordsSet).join(', ');
  };
  
  // Extract dynamic keywords
  const keywords = extractKeywords();

  return (
    <>
    {/* Helmet for SEO */}
    <Helmet>
      <title>Sweatshirts Collection</title>
      <meta
        name="description"
        content="Explore our exclusive collection of sweatshirts. Available in various styles, sizes, and designs."
      />
      <meta name="keywords" content={keywords} />
    </Helmet>

    
    <div className="bg-gray-100">
        
        <div className="bg-black text-white text-center py-4 px-6">
          <h2 className="text-3xl sm:text-xl md:text-2xl font-bold mb-3 mt-2">
            Thank you !!!
          </h2>
          <p className="text-xl sm:text-base md:text-lg mb-2">
            We would like to thank everyone who has visited our website, as well as those who are purchasing our products and <br/> trusting us on our journey.
          </p>
        </div>  
       
      <div className="max-w-screen-lg mx-auto px-4">
        {/* Section 1 */}
        <section className="flex flex-col md:flex-row items-center py-12 gap-8">
          <div className="flex-1">
            <div>
            <button className="bg-[#FF4902] text-white px-4 py-2 rounded mb-4">Our Focus</button>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Step Into Mammoth Streetwear Where Style Meets Trendsetting Fashion
            </h2>
            <p className="text-gray-700 mb-6">
              We are growing, building, and striving to be the best. Our goal is to provide top-quality products at
              affordable prices. We are among the few companies that offer both print-on-demand and bulk ordering
              options.
            </p>
            <ul className="space-y-3">
              {[
                'Top quality prints using the latest technology',
                'Mix and match colors, sizes, and designs',
                'Fast and free standard shipping',
                'Customer happiness guarantee',
              ].map((text, index) => (
                <li key={index} className="flex items-center gap-2">
                  <TiTick className="text-black-600 text-4xl bg-[#FDE3D9] p-2 rounded-full" /> {text}
                </li>
              ))}
            </ul>
            <div>
            <button 
              className="bg-[#FF4902] text-white px-6 py-2 rounded mt-6" 
              onClick={() => navigate("/collection")}
            >
               Shop Now
               </button>
            </div>
          </div>
          <div className="flex-1">
            <img
              src="https://res.cloudinary.com/djqeoutoy/image/upload/v1733386468/Group_66_djbsr1.png"
              alt="Streetwear"
              className="w-full h-auto rounded-lg "
            />
          </div>
        </section>

        {/* Section 2 */}
        <section className="flex flex-col md:flex-row items-center py-12 gap-8 bg-gray-100">
          <div className="flex-1">
            <img
              src="https://res.cloudinary.com/djqeoutoy/image/upload/v1733386468/Group_67_jff7mn.png"
              alt="Why Us"
              className="w-full h-auto rounded-lg "
            />
          </div>
          <div className="flex-1">
            <button className="bg-[#FF4902] text-white px-4 py-2 rounded mb-4">Why Us</button>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              There are many competitors in the market, but what sets us apart is our USP:
            </h2>
            <ul className="space-y-3">
              {[
                'Striking Streetwear Designs that Give Goosebumps to the Crowd.',
                'Print on Demand Services',
                'Customization Options',
                'Unmatched Quality',
                'Affordable Pricing',
                'Guaranteed Trustworthy Products',
                'Easy Exchange & Return Policy',
              ].map((text, index) => (
                <li key={index} className="flex items-center gap-2">
                  <TiTick className="text-black-600 text-4xl bg-[#FDE3D9] p-2 rounded-full" /> {text}
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Section 3 */}
        <section className="py-12 bg-gray-100">
          <div className="text-center mb-8">
            <button className="bg-[#FF4902] text-white px-4 py-2 rounded mb-4">Fast and Quality Service</button>
            <h2 className="text-3xl md:text-4xl font-bold">T-shirt printing made easy.</h2>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <img
                src="https://res.cloudinary.com/djqeoutoy/image/upload/v1733386468/Group_68_nzmzwy.png"
                alt="Custom Services"
                className="w-full h-auto rounded-lg "
              />
            </div>
            <div className="flex-1">
              {dropdownData.map((item, index) => (
                <div key={index} className="mb-4">
                  <button
                    className={`flex justify-between items-center px-4 py-2 rounded w-full text-left ${
                      activeDropdown === index ? 'bg-[#FF4902] text-white' : 'bg-[#FDE3D9]'
                    }`}
                    onClick={() => toggleDropdown(index)}
                  >
                    {item.title} <IoIosArrowDropdown />
                  </button>
                  {activeDropdown === index && (
                    <p className="bg-white p-4 mt-2 rounded shadow">{item.content}</p>
                  )}
                </div>
              ))}
              <button className="bg-[#FF4902] text-white px-6 py-2 rounded mt-6">Custom T-shirt</button>
            </div>
          </div>
        </section>
      </div>
         {/* Navbar Section */}
        
        {/* Stats Component */}
        {/* <div className="flex justify-center items-center my-8 bg-gray-100">
           <Stats />
        </div> */}
     


         {/* Testimonials Section */}
         {/* <div className="my-10 bg-gray-100 rounded-sm p-6"> */}
  {/* Heading */}
  {/* <div className="text-center mb-8">
    <div className="inline-block bg-[#FF4902] text-white rounded-full px-4 py-2">
      <h2 className=" ">Testimonials</h2>
    </div>
    <p className="font-semibold text-3xl mt-4">What Mammals Are Saying</p>
  </div> */}

  {/* Cards */}
  {/* <div className="relative mt-8 px-4 md:px-16"> {/* Adjusted padding for smaller screens */}
  {/* Left Button */}
  {/* <button
    onClick={handlePrev}
    className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-md hover:bg-gray-400 focus:outline-none"
  >
    &#8249; {/* Left arrow */}
  {/* </button> */} 

  {/* Testimonials Cards
  <div className="flex overflow-hidden">
    {testimonialsData.slice(currentIndex, currentIndex + cardsToShow).map((item, index) => (
      <div
        key={index}
        className="flex items-start bg-white rounded-lg shadow-lg mx-4 p-4 w-full sm:w-full md:w-1/3 lg:w-1/3 h-[280px] sm:h-[260px]" // Adjusted width for small and medium devices
      >
        <img
          src={item.photo}
          alt={`${item.name}`}
          className="w-16 h-16 rounded-full object-cover mr-4"
        />
        <div>
          <h3 className="font-bold text-lg">{item.name}</h3>
          <p className="text-sm text-gray-500">{item.designation}</p>
          <p className="mt-4 text-gray-700"> {`"`} {item.review} {`"`}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Right Button */}
  {/* <button
    onClick={handleNext}
    className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-md hover:bg-gray-400 focus:outline-none"
  >
    &#8250; 
  </button> */}

  {/* Navigation Dots */}
  {/* <div className="flex justify-center mt-6">
    {Array.from({ length: Math.ceil(testimonialsData.length / cardsToShow) }).map((_, index) => (
      <div
        key={index}
        onClick={() => setCurrentIndex(index * cardsToShow)}
        className={`h-3 w-3 mx-1 rounded-full ${
          currentIndex / cardsToShow === index ? "bg-[#FF4902]" : "bg-gray-300"
        }`}
      ></div>
    ))}
  </div>
</div>
</div> */} 

   <Testimonials/>

         <NavbarBanner />
    </div>
    </> 
  );
};

export default About;
